<template>
	<section class="rev_slider_wrapper">
		<div id="slider1" class="rev_slider" data-version="5.0">
			<ul>
				<li v-for="(item,index) in data" data-transition="parallaxvertical">
					<img :src="item.banner_img" alt="" width="1920" height="400" data-bgposition="top center" data-bgfit="cover" data-bgrepeat="no-repeat" data-bgparallax="1">
					<div class="tp-caption sfl tp-resizeme thm-banner-h1 blue-bg" data-x="left" data-hoffset="0" data-y="top" data-voffset="109" data-whitespace="nowrap" data-transform_idle="o:1;" data-transform_in="o:0" data-transform_out="o:0" data-start="500">
						{{item.banner_title}}
					</div>
					<div class="tp-caption sfr tp-resizeme thm-banner-h1 heavy black-bg" data-x="left" data-hoffset="0" data-y="top" data-voffset="180" data-whitespace="nowrap" data-transform_idle="o:1;" data-transform_in="o:0" data-transform_out="o:0" data-start="1000">
						{{item.banner_subtitle}}
					</div>
					<div class="tp-caption sfb tp-resizeme thm-banner-p" data-x="left" data-hoffset="0" data-y="top" data-voffset="253" data-whitespace="nowrap" data-transform_idle="o:1;" data-transform_in="o:0" data-transform_out="o:0" data-start="1500">
						{{item.banner_intro}}
					</div>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
	import tmp from "@/assets/js/tmp.js";
	export default{
		name: 'banner',
		props:['data'],
		data(){
			return{
				banner: tmp.home.banner
			}
		},
		mounted(){
  			$("#slider1").revolution({
	            sliderType: "standard",
	            sliderLayout: "auto",
	            delay: 5000,
	            navigation: {
	                arrows: { enable: true }
	            },
	            gridwidth: 1170,
	            gridheight: 400
	        });
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/home/Banner.vue